import Service from "../DepartmentService";

function GetById() {
    return Service.get('Department');
}


function GetService() {
    return Service.get('DepartmentSettings/GetService');
}


function GetColumnConfig(servicetype) {
    return Service.get('DepartmentSettings/ColumnConfig/' + servicetype);
}

function GetDepartmentByDivisionId() {
    return Service.get('PublicPage/GetDepartments');
}



const DepartmentService = {
    GetById,
    GetService,
    GetColumnConfig,
    GetDepartmentByDivisionId
};

export default DepartmentService;
